export default {
  independentMarketing: {
    common: {
      requestFailed: 'คำขออินเทอร์เฟซล้มเหลว',
      hintSelect: 'เลือก',
      hintInput: 'เข้า',
      submit: 'ส่ง',
      cancel: 'ยกเลิก',
      confirm: 'ตกลง',
    },
    agreement: {
      title: 'ข้อตกลงการลงทะเบียนตัวแทนจำหน่ายอิสระ Autel',
      nextBtn: 'ถัดไป',
      getAgreementFailed: 'ไม่สามารถรับเนื้อหาข้อตกลงได้',
    },
    successPage: {
      title:
        'ข้อมูลการสมัครของคุณถูกส่งเรียบร้อยแล้ว และผลการตรวจสอบจะถูกส่งไปยังอีเมล $1 ของคุณภายใน 15 วันทำการ โปรดตรวจสอบกล่องจดหมายของคุณสำหรับข้อมูลเพิ่มเติม',
      subTitle: 'กลับไปที่หน้าแรกหลังจาก $1 วินาที',
    },
    applyTitle: 'คุณกำลังสมัครเป็นตัวแทนจำหน่ายอิสระของ Autel กรุณากรอกข้อมูลต่อไปนี้ให้ถูกต้อง:',
    companyName: 'ชื่อบริษัท',
    companyTax: 'VAT ID',
    userCountry: 'ประเทศ',
    legalPerson: 'ที่ปรึกษาทางกฎหมาย',
    contactEmail: 'อีเมล์ติดต่อ',
    contactEmailTips:
      'ที่อยู่อีเมลนี้จะเป็นข้อมูลติดต่อของคุณสำหรับอีเมลผลการตรวจสอบ เมื่อการตรวจสอบได้รับการอนุมัติ ก็จะใช้เป็นชื่อบัญชีเข้าสู่ระบบสำหรับระบบการจัดการตัวแทนจำหน่ายอิสระด้วย',
    corporateIdentity: 'รหัสที่ปรึกษากฎหมาย',
    uploadTips: 'JPG, JPEG, PNG, PDF (ไม่เกิน 20 MB)',
    businessLicense: 'ใบอนุญาตประกอบธุรกิจ',
    emailErrorTips: 'ป้อนอีเมล์ที่ถูกต้อง',
    uploadPic: 'อัพโหลดภาพ',
    picMaxLimit: 'ขนาดภาพสูงสุดคือ 20 MB โปรดเลือกอีกครั้ง',
  },
};
